export function formatCreditCost(amount: number): string {
  return `${amount} CR`;
}

export function formatInsufficientCreditsMessage(
  template: string,
  amount: number
): string {
  return template.replace('{cost}', formatCreditCost(amount));
}
